import { HttpInterceptor } from './../common/services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { ConfigService } from './../common/services/config.service';
@Injectable()
export class PaymentStatusService {
  constructor(private _httpInterceptor: HttpInterceptor) { }

  public FetchPaymentStatus(fetchPaymentData: any) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPaymentStatus;
    url = url.replace('{applicationId}', fetchPaymentData.applicationId);
    url = url.replace('{quoteId}', fetchPaymentData.quoteId);
    return this._httpInterceptor.Get(url, true);
  }
}
